export default "__VITE_ASSET__BP$$eban__"